import { Container, Grid, Box, Link, List, ListItem } from '@mui/material';
import React from 'react';
import { NavLink } from 'react-router-dom';
import FooterScss from './Footer.module.scss';
import office1 from '../../Common/Image/office1.jpg'
function Footer() {
    return (
        <footer className={FooterScss.footer}>
            <Container maxLength='lg' >
                <Grid container sx={{ mx: "-10px", width: "auto" }}>
                    <Grid item xs={12} sm={6} md={3} sx={{ px: '10px' }}>
                        <Box className={FooterScss.footLeft}>
                            <span className={FooterScss.footLogo}>busin</span>
                            <Box className={FooterScss.footLeftContact}>
                                <Link href='mailto:xamiyev_enver@mail.ru'>xamiyev_enver@mail.ru</Link>
                                <Link href='tel:+994555555555'>(+99455) 555 55 55</Link>
                            </Box>
                            <address>
                                Po Box 768 Occidental, California(CA), 95465
                            </address>
                        </Box>

                    </Grid>
                    <Grid item xs={12} sm={6} md={3} sx={{ px: '10px' }}>
                        <Box className={FooterScss.footlink}>
                            <h6>extra links</h6>
                            <List >
                                <ListItem>
                                    <Link href='#'>extra links</Link>
                                </ListItem>
                                <ListItem>
                                    <Link href='#'>about us</Link>
                                </ListItem>
                                <ListItem>
                                    <NavLink to="/OurService">services</NavLink>
                                </ListItem>
                                <ListItem>
                                    <NavLink to="/Pricing">pricing</NavLink>
                                </ListItem>
                                <ListItem>
                                    <Link href='#'>features</Link>
                                </ListItem>
                                <ListItem>
                                    <NavLink to="/Works">how it works</NavLink>
                                </ListItem>
                                <ListItem>
                                    <NavLink to="/Faq">f.a.q</NavLink>
                                </ListItem>
                                <ListItem>
                                    <NavLink to="/Contact">contact us</NavLink>
                                </ListItem>
                                <ListItem>
                                    <NavLink to="/Masonry">masonry</NavLink>
                                </ListItem>
                            </List>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} sx={{ px: '10px' }}>
                        <Box className={FooterScss.footRecent}>
                            <h6>recent posts</h6>
                            <List className={FooterScss.footRecentPost}>
                                <ListItem>
                                    <Box className={FooterScss.footRecentPostItem}>
                                        <Box className={FooterScss.footRecentPostItemImg}>
                                            <img src={office1} alt='office1'></img>
                                        </Box>
                                        <Box className={FooterScss.footRecentPostItemContent}>
                                            <Link href="#">On the head with free internet</Link>
                                            <Box className={FooterScss.footRecentPostItemContentDate}>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M160 32V64H288V32C288 14.33 302.3 0 320 0C337.7 0 352 14.33 352 32V64H400C426.5 64 448 85.49 448 112V160H0V112C0 85.49 21.49 64 48 64H96V32C96 14.33 110.3 0 128 0C145.7 0 160 14.33 160 32zM0 192H448V464C448 490.5 426.5 512 400 512H48C21.49 512 0 490.5 0 464V192zM64 304C64 312.8 71.16 320 80 320H112C120.8 320 128 312.8 128 304V272C128 263.2 120.8 256 112 256H80C71.16 256 64 263.2 64 272V304zM192 304C192 312.8 199.2 320 208 320H240C248.8 320 256 312.8 256 304V272C256 263.2 248.8 256 240 256H208C199.2 256 192 263.2 192 272V304zM336 256C327.2 256 320 263.2 320 272V304C320 312.8 327.2 320 336 320H368C376.8 320 384 312.8 384 304V272C384 263.2 376.8 256 368 256H336zM64 432C64 440.8 71.16 448 80 448H112C120.8 448 128 440.8 128 432V400C128 391.2 120.8 384 112 384H80C71.16 384 64 391.2 64 400V432zM208 384C199.2 384 192 391.2 192 400V432C192 440.8 199.2 448 208 448H240C248.8 448 256 440.8 256 432V400C256 391.2 248.8 384 240 384H208zM320 432C320 440.8 327.2 448 336 448H368C376.8 448 384 440.8 384 432V400C384 391.2 376.8 384 368 384H336C327.2 384 320 391.2 320 400V432z" /></svg>
                                                <span>June 15,2022</span>
                                            </Box>
                                        </Box>
                                    </Box>
                                </ListItem>
                                <ListItem>
                                    <Box className={FooterScss.footRecentPostItem}>
                                        <Box className={FooterScss.footRecentPostItemImg}>
                                            <img src={office1} alt='office1'></img>
                                        </Box>
                                        <Box className={FooterScss.footRecentPostItemContent}>
                                            <Link href="#">On the head with free internet</Link>
                                            <Box className={FooterScss.footRecentPostItemContentDate}>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M160 32V64H288V32C288 14.33 302.3 0 320 0C337.7 0 352 14.33 352 32V64H400C426.5 64 448 85.49 448 112V160H0V112C0 85.49 21.49 64 48 64H96V32C96 14.33 110.3 0 128 0C145.7 0 160 14.33 160 32zM0 192H448V464C448 490.5 426.5 512 400 512H48C21.49 512 0 490.5 0 464V192zM64 304C64 312.8 71.16 320 80 320H112C120.8 320 128 312.8 128 304V272C128 263.2 120.8 256 112 256H80C71.16 256 64 263.2 64 272V304zM192 304C192 312.8 199.2 320 208 320H240C248.8 320 256 312.8 256 304V272C256 263.2 248.8 256 240 256H208C199.2 256 192 263.2 192 272V304zM336 256C327.2 256 320 263.2 320 272V304C320 312.8 327.2 320 336 320H368C376.8 320 384 312.8 384 304V272C384 263.2 376.8 256 368 256H336zM64 432C64 440.8 71.16 448 80 448H112C120.8 448 128 440.8 128 432V400C128 391.2 120.8 384 112 384H80C71.16 384 64 391.2 64 400V432zM208 384C199.2 384 192 391.2 192 400V432C192 440.8 199.2 448 208 448H240C248.8 448 256 440.8 256 432V400C256 391.2 248.8 384 240 384H208zM320 432C320 440.8 327.2 448 336 448H368C376.8 448 384 440.8 384 432V400C384 391.2 376.8 384 368 384H336C327.2 384 320 391.2 320 400V432z" /></svg>
                                                <span>June 15,2022</span>
                                            </Box>
                                        </Box>
                                    </Box>
                                </ListItem>
                            </List>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} sx={{ px: '10px' }}>
                        <Box className={FooterScss.footSubscribe}>
                            <h6>subscribe</h6>
                            <form>
                                <Box className={FooterScss.footSubscribeEmailBox}>
                                    <input type="email" placeholder="Your email"></input>
                                    <button type='submit'>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M504.3 273.6l-112.1 104c-6.992 6.484-17.18 8.218-25.94 4.406c-8.758-3.812-14.42-12.45-14.42-21.1L351.9 288H32C14.33 288 .0002 273.7 .0002 255.1S14.33 224 32 224h319.9l0-72c0-9.547 5.66-18.19 14.42-22c8.754-3.809 18.95-2.075 25.94 4.41l112.1 104C514.6 247.9 514.6 264.1 504.3 273.6z" /></svg>
                                    </button>
                                </Box>
                            </form>
                            <p>Get lastest updates and offers</p>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </footer>
    )
}

export default Footer;